import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetEdc_sharing_groupIdSettlementExport = z.any()
export type TagsGetEdc_sharing_groupIdSettlementExport = z.infer<typeof tagsGetEdc_sharing_groupIdSettlementExport>

export const paramsGetEdc_sharing_groupIdSettlementExport = z.object({ "groupId": z.string() })
export type ParamsGetEdc_sharing_groupIdSettlementExport = z.infer<typeof paramsGetEdc_sharing_groupIdSettlementExport>

export const querystringGetEdc_sharing_groupIdSettlementExport = z.object({ "from": z.string().date(), "to": z.string().date() })
export type QuerystringGetEdc_sharing_groupIdSettlementExport = z.infer<typeof querystringGetEdc_sharing_groupIdSettlementExport>

export const responseGetEdc_sharing_groupIdSettlementExport = z.any()
export type ResponseGetEdc_sharing_groupIdSettlementExport = z.infer<typeof responseGetEdc_sharing_groupIdSettlementExport>

interface IGetEdc_sharing_groupIdSettlementExport extends BaseMethodType {
  tags: TagsGetEdc_sharing_groupIdSettlementExport,
  params: ParamsGetEdc_sharing_groupIdSettlementExport,
  querystring: QuerystringGetEdc_sharing_groupIdSettlementExport,
  response: ResponseGetEdc_sharing_groupIdSettlementExport
}
export const URL = '/edc-sharing/:groupId/settlement/export'
export const validation = {
  get: {
    tags: tagsGetEdc_sharing_groupIdSettlementExport,
    params: paramsGetEdc_sharing_groupIdSettlementExport,
    querystring: querystringGetEdc_sharing_groupIdSettlementExport,
    response: responseGetEdc_sharing_groupIdSettlementExport
  }
}
export interface Edc_sharing_groupIdSettlementExport extends BaseRouteType {
  get: IGetEdc_sharing_groupIdSettlementExport
}